/* Repli autoplay des boucles vidéo muettes (LP-Bank, 01/10/2026).
   Quand le navigateur refuse la lecture automatique (mode économie d'énergie iPhone/Mac,
   Safari « Ne jamais lire automatiquement »), une boucle muette reste figée sur son poster.
   Ce script s'ajoute au code de la page sans le modifier : dès qu'une boucle visible reste
   en pause, il affiche un bouton ▶ par-dessus, et tout tap/clic/touche relance les boucles visibles.
   Inclusion : <script src="/_media/video-boucle-repli.js?v=…" defer data-autoplay-fallback></script>
   Ne touche PAS aux lecteurs qui ont déjà leur propre bouton : avis vidéo (.pvr-card), désabo (#pdvid-7rp),
   lecteurs [data-pv], vidéo flottante (#floatvid), VSL (.vsl-player), boucles déjà gérées en ligne (.lv). */
(function () {
  'use strict';
  var SEL = 'video[data-lazy="autoplay"], video.fcta-video, video.lazy-video, video[autoplay][muted], video[data-loop], .feat-video video, .abx-vid video';
  var SKIP = '[data-pv], .pvr-card, #pdvid-7rp, .lv, #floatvid, .vsl-player';
  var LABEL = { fr: 'Lire la vidéo', en: 'Play video', de: 'Video abspielen', nl: 'Video afspelen', da: 'Afspil video', pl: 'Odtwórz wideo' };
  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var label = LABEL[lang] || LABEL.fr;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';
  var items = [], styled = false, wired = false;
  // Lecteurs « une diapo à la fois » (pop-up absorption) : la page met volontairement en pause les diapos voisines.
  // Pour eux, on ne lance rien soi-même ; le bouton n'apparaît que si le navigateur a VRAIMENT refusé la lecture.
  var PASSIVE = '.abx-vid video';
  // On note chaque refus de lecture (NotAllowedError), quel que soit le script de la page qui a appelé play().
  var nativePlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    var v = this, p = nativePlay.apply(v, arguments);
    if (p && p.then) p.then(function () { v.__vbrBlocked = false; }, function (e) {
      if (!e || e.name !== 'NotAllowedError') return;
      v.__vbrBlocked = true;
      if (v.__vbrItem && shown(v) >= 0.5) show(v.__vbrItem);
    });
    return p;
  };

  function vw() { return window.innerWidth || document.documentElement.clientWidth; }
  function vh() { return window.innerHeight || document.documentElement.clientHeight; }
  // Part de la vidéo réellement à l'écran (0 à 1). Exiger la moitié évite de lancer la diapo voisine d'un carrousel.
  function shown(v) {
    var r = v.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return 0;
    var w = Math.min(r.right, vw()) - Math.max(r.left, 0), h = Math.min(r.bottom, vh()) - Math.max(r.top, 0);
    return w > 0 && h > 0 ? (w * h) / (r.width * r.height) : 0;
  }
  function ready(v) { return !!(v.currentSrc || v.getAttribute('src') || v.querySelector('source[src]')); }

  // Le bouton est centré sur la vidéo, sans toucher au CSS de la page (pas d'enveloppe, pas de position:relative ajouté).
  function place(it) {
    var P = it.b.offsetParent, vr = it.v.getBoundingClientRect(), x, y;
    if (!P || P === document.body || P === document.documentElement || getComputedStyle(P).position === 'static') {
      x = vr.left + window.pageXOffset; y = vr.top + window.pageYOffset;
    } else {
      var pr = P.getBoundingClientRect();
      x = vr.left - pr.left - P.clientLeft + P.scrollLeft; y = vr.top - pr.top - P.clientTop + P.scrollTop;
    }
    it.b.style.left = (x + vr.width / 2) + 'px'; it.b.style.top = (y + vr.height / 2) + 'px';
  }
  var raf = 0;
  function replaceAll() { raf = 0; items.forEach(function (it) { if (it.on) place(it); }); }
  function queue() { if (!raf) raf = (window.requestAnimationFrame || setTimeout)(replaceAll); }

  function show(it) { if (it.on || !it.v.paused) return; it.on = true; it.b.classList.add('is-on'); place(it); }
  function hide(it) { if (!it.on) return; it.on = false; it.b.classList.remove('is-on'); }
  function play(it) {
    var v = it.v, p;
    v.muted = true;
    try { p = v.play(); } catch (e) { show(it); return; }
    if (p && p.then) p.then(function () { hide(it); }, function (e) { if (!e || e.name !== 'AbortError') show(it); });
  }
  // Vidéo visible : si elle est en pause, on tente la lecture ; toujours en pause 2 s plus tard alors qu'elle a
  // déjà de quoi s'afficher (readyState ≥ 2) = bloquée → bouton. Une vidéo encore en chargement n'a pas de bouton.
  function check(it) {
    if (it.passive) { if (it.v.paused && it.v.__vbrBlocked && shown(it.v) >= 0.5) show(it); return; }
    if (!it.v.paused || shown(it.v) < 0.5) return;
    if (ready(it.v)) play(it);
    setTimeout(function () { if (it.v.paused && shown(it.v) >= 0.5 && it.v.readyState >= 2) show(it); }, 2000);
  }
  function retry() { items.forEach(function (it) { if (!it.passive && it.v.paused && shown(it.v) >= 0.5 && ready(it.v)) play(it); }); }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (e.intersectionRatio < 0.5) return;
      for (var i = 0; i < items.length; i++) if (items[i].v === e.target) { check(items[i]); break; }
    });
  }, { threshold: [0.5] }) : null;

  // Idempotent : relancé au chargement complet pour attraper les vidéos créées tard par la page.
  function scan() {
    var vids = [].slice.call(document.querySelectorAll(SEL)).filter(function (v) {
      return !v.__vbr && !v.hasAttribute('controls') && !v.closest(SKIP);
    });
    if (!vids.length) return;
    if (!styled) {
      styled = true;
      var st = document.createElement('style');
      // !important + double classe : certaines pages ont un « button{margin:0} » global qui décalait le bouton (1008, 01/10/2026)
      var I = ' !important;';
      st.textContent = '.vbr-play.vbr-play{position:absolute' + I + 'width:60px' + I + 'height:60px' + I + 'min-width:0' + I + 'min-height:0' + I +
        'margin:-30px 0 0 -30px' + I + 'transform:none' + I + 'box-sizing:border-box' + I + 'border-radius:50%' + I + 'border:0' + I + 'padding:0' + I +
        'background:rgba(17,17,17,.6)' + I + 'color:#fff' + I + 'display:none' + I + 'align-items:center' + I + 'justify-content:center' + I +
        'cursor:pointer;z-index:6' + I + 'box-shadow:none' + I + '-webkit-tap-highlight-color:transparent}' +
        '.vbr-play.vbr-play.is-on{display:flex' + I + '}.vbr-play.vbr-play svg{width:26px' + I + 'height:26px' + I + 'margin:0 0 0 4px' + I + 'fill:currentColor' + I + '}';
      document.head.appendChild(st);
    }
    vids.forEach(function (v) {
      v.__vbr = true;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vbr-play'; b.setAttribute('aria-label', label); b.innerHTML = ICON;
      v.parentNode.insertBefore(b, v.nextSibling);
      var it = { v: v, b: b, on: false, passive: v.matches(PASSIVE) };
      v.__vbrItem = it;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); play(it); });
      v.addEventListener('playing', function () { hide(it); });
      items.push(it);
      if (io) io.observe(v); else setTimeout(function () { check(it); }, 1500);
    });
    if (!wired) {
      wired = true;
      // capture : attrape aussi le défilement des carrousels (un scroll interne ne remonte pas jusqu'à window)
      window.addEventListener('scroll', queue, { passive: true, capture: true });
      window.addEventListener('resize', queue);
      // Un geste de l'utilisateur autorise la lecture : on relance les boucles visibles restées bloquées.
      ['touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, retry, { passive: true }); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
})();
